import './CheckBoxItem.css';
import type { DiFiCheckBoxItemProps } from './types';
import { bindActivate, disabledClass, resolveLabel, rootA11y } from './shared';

const DEFAULT_FILL = '#1060FF';
const DEFAULT_BORDER = '#E4E4E4';

const CheckedIcon = (iconProps: { fill: string }) => (
  <svg width="18" height="18" viewBox="0 0 18 18" stroke="none" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="1" y="1" width="16" height="16" rx="4" fill={iconProps.fill} />
    <path
      d="M12 7L8.44 10.6485C8 11.1172 8 11.1172 7.50667 10.6485L6 9.21694"
      stroke="white"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

const UncheckedIcon = (iconProps: { border: string }) => (
  <svg width="18" height="18" viewBox="0 0 18 18" stroke="none" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="1.5" y="1.5" width="15" height="15" rx="3.5" stroke={iconProps.border} />
  </svg>
);

/** 方框 + 勾选多选 */
export const CheckBoxItem = (props: DiFiCheckBoxItemProps) => {
  const activate = bindActivate(props.itemProps);
  const a11y = rootA11y(props.itemProps);

  return (
    <div
      class={disabledClass(props.itemProps, 'difi-checkbox-item')}
      style={props.itemProps.style}
      {...a11y}
      {...activate}
    >
      <span class="difi-checkbox-item__box" data-tap-activate="" aria-hidden="true">
        {props.itemProps.checked === true ? (
          <CheckedIcon fill={props.itemProps.activeColor ?? DEFAULT_FILL} />
        ) : (
          <UncheckedIcon border={props.itemProps.defaultColor ?? DEFAULT_BORDER} />
        )}
      </span>
      {resolveLabel(props.itemProps, 'difi-checkbox-item__label', true)}
    </div>
  );
};
